import i18next from 'i18next';

import { Resources } from '@egr/room/modules/Resources';

export class RoomResources implements Resources {
    public get materialColor(): string { return i18next.t('Color'); }
    public get propertyArea(): string { return i18next.t('Area'); }
    public get propertyArenaShape(): string { return i18next.t('Shape'); }
    public get propertyArenaOval(): string { return i18next.t('Oval'); }
    public get propertyArenaCircle(): string { return i18next.t('Circle'); }
    public get propertyBackgroundImage(): string { return i18next.t('Background Image'); }
    public get propertyBlind(): string { return i18next.t('Blind'); }
    public get propertyColor(): string { return i18next.t('Color'); }
    public get propertyDepth(): string { return i18next.t('Depth'); }
    public get propertyDiameter(): string { return i18next.t('Diameter'); }
    public get propertyHeight(): string { return i18next.t('Height'); }
    public get propertyLabel(): string { return i18next.t('Label'); }
    public get propertyLaneCount(): string { return i18next.t('Lane Count'); }
    public get propertyLaneLength(): string { return i18next.t('Inner Lane Length'); }
    public get propertyLaneLengthOffset(): string { return i18next.t('Straight Track Offset'); }
    public get propertyLength(): string { return i18next.t('Length'); }
    public get propertyMaterial(): string { return i18next.t('Material'); }
    public get propertyMaterial_Arena_TrackLane(): string { return i18next.t('Material Track Lane'); }
    public get propertyMaterial_Arena_PlayField(): string { return i18next.t('Material Playing Field'); }
    public get propertyMaterial_Arena_SideSegments(): string { return i18next.t('Material Side Segments'); }
    public get propertyMaterial_Arena_TrackLine(): string { return i18next.t('Material Track Line'); }
    public get propertyOnSite(): string { return i18next.t('On Site'); }
    public get propertyOpeningAngle(): string { return i18next.t('Opening Angle'); }
    public get propertyOpeningWidth(): string { return i18next.t('Opening Width'); }
    public get propertyParapet(): string { return i18next.t('Parapet'); }
    public get propertyPerimeter(): string { return i18next.t('Perimeter'); }
    public get propertyPrivacyFilter(): string { return i18next.t('Privacy Filter'); }
    public get propertyProportional(): string { return i18next.t('Proportional'); }
    public get propertyRouteWidth(): string { return i18next.t('Route Width'); }
    public get propertySegments(): string { return i18next.t('Segments'); }
    public get propertyScalePercantage(): string { return i18next.t('Scale (%)'); }
    public get propertySpeed_Slow(): string { return i18next.t('Slow'); }
    public get propertySpeed_Medium(): string { return i18next.t('Medium'); }
    public get propertySpeed_Fast(): string { return i18next.t('Fast'); }
    public get propertyText(): string { return i18next.t('Text'); }
    public get propertyTextureOffsetU(): string { return i18next.t('Offset Hor'); }
    public get propertyTextureOffsetV(): string { return i18next.t('Offset Ver'); }
    public get propertyTextureScaleU(): string { return i18next.t('Scale Hor'); }
    public get propertyTextureScaleV(): string { return i18next.t('Scale Ver'); }
    public get propertyThickness(): string { return i18next.t('Thickness'); }
    public get propertyWidth(): string { return i18next.t('Width'); }
    public get propertyWallSideA(): string { return i18next.t('Wall Side a'); }
    public get propertyWallSideB(): string { return i18next.t('Wall Side b'); }
    public get propertyValueNo(): string { return i18next.t('No'); }
    public get propertyValueYes(): string { return i18next.t('Yes'); }
    public get propertyTransparency(): string { return i18next.t('Transparency'); }
    public get propertyOpacity(): string { return i18next.t('Opacity'); }
    public get propertyMaterialCategory(): string { return i18next.t('Material category'); }
    public get propertyRoadWidth(): string { return i18next.t('Road Width'); }
    public get propertyColor_Black(): string { return i18next.t('Black'); }
    public get propertyColor_DarkRed(): string { return i18next.t('Dark Red'); }
    public get propertyColor_Red(): string { return i18next.t('Red'); }
    public get propertyColor_Orange(): string { return i18next.t('Orange'); }
    public get propertyColor_Yellow(): string { return i18next.t('Yellow'); }
    public get propertyColor_Green(): string { return i18next.t('Green'); }
    public get propertyColor_LightBlue(): string { return i18next.t('Light Blue'); }
    public get propertyColor_DarkBlue(): string { return i18next.t('Dark Blue'); }
    public get propertyColor_Purple(): string { return i18next.t('Purple'); }
    public get propertyColor_Pink(): string { return i18next.t('Pink'); }
    public get propertyRadius(): string { return i18next.t('Radius'); }
    public get propertyTextHeight(): string { return i18next.t('Text Height'); }
    public get propertyAlternativeText(): string { return i18next.t('Alternative Text'); }
    public get propertyCurrentLength(): string { return i18next.t('Current Length'); }
    public get propertyTextDisplay(): string { return i18next.t('Text Display'); }
    public get propertyCustomColor(): string { return i18next.t('Custom Color'); }
    public get propertyCurvedWay(): string { return i18next.t('Curved Way'); }
    public get propertyCrossHair(): string { return i18next.t('Show triangle point (2d)'); }
    public get propertyCurvedLine(): string { return i18next.t('Curved'); }
    public get propertyPropClass_base(): string { return i18next.t('Base properties'); }
    public get propertyClass_Fence_Field(): string { return i18next.t('Field'); }
    public get propertyClass_Fence_Posts(): string { return i18next.t('Posts'); }
    public get propertyFenceFieldLength(): string { return i18next.t('Field length'); }
    public get propertyFenceClosedOpen(): string { return i18next.t('Fence closed'); }
    public get propertyFenceMirrorTexture(): string { return 'Mirror texture'; }
    public get propertyFenceRoundPosts(): string { return 'Round Posts'; }
    public get propertyDistance(): string { return 'Distance'; }
    public get propertyDoorType(): string { return 'Door type'; }
    public get propertyDoorType_solid(): string { return 'Solid'; }
    public get propertyDoorType_inlay(): string { return 'Inlay'; }
    public get propertyDoorType_glass(): string { return 'Glass'; }
    public get propertyDoorLeafCount(): string { return 'Door Leaf Count'; }
    public get propertyChalkboard(): string { return 'Chalkboard'; }
    public get propertyClass_Additional(): string { return 'Additional'; }
    public get propertyClass_Sound(): string { return 'Sound'; }
    public get propertyColumnWidth(): string { return 'Column Width'; }
    public get propertyDoorSill(): string { return 'Door sill'; }
    public get propertyDoorLeaf(): string { return 'Door leaf'; }
    public get propertyDoorFrame(): string { return 'Door frame'; }
    public get propertyFanLight(): string { return 'Fanlight'; }
    public get propertyEnabled(): string { return 'Enabled'; }
    public get propertyFrameColor(): string { return 'Frame color'; }
    public get propertyFrameWidth(): string { return 'Frame width'; }
    public get propertyGlazingBars(): string { return 'Glazing Bar'; }
    public get propertyGlazingBarsWidth(): string { return 'Bar Width'; }
    public get propertyGlazingBarsHorizontal(): string { return 'Horizontal Glazing Bars'; }
    public get propertyGlazingBarsVertical(): string { return 'Vertical Glazing Bars'; }
    public get propertyKeepVisible(): string { return 'Keep visible'; }
    public get propertyHandleHeight(): string { return 'Handle Height'; }
    public get propertyPictureFrameCustom(): string { return 'Picture frame custom'; }
    public get propertyPictureFrameType(): string { return 'Type'; }
    public get propertyRotationAngle(): string { return 'Rotation angle'; }
    public get propertySuspensionHeight(): string { return 'Suspension height'; }
    public get propertyWindowSill(): string { return 'Sill'; }
    public get propertyWhiteBoard(): string { return 'Whiteboard'; }
    public get propertySash(): string { return 'Sash'; }
    public get propertyVisibility(): string { return 'Visible'; }
    public get propertyVisible(): string { return 'Visible'; }
    public get propertyTransparent(): string { return 'Transparent'; }
    public get propertycameraCustomTarget(): string { return 'Custom target'; }
    public get propertycameraTargetHeight(): string { return 'Target height'; }
    public get propertycameraViewAlongPath(): string { return 'View along path'; }
    public get propertyAnimationSpeed(): string { return 'Animation speed'; }
    public get propertyTerrain_HillHeight(): string { return 'Hill height'; }
    public get propertyTerrain_HillOffset(): string { return 'Hill offset'; }
    public get propertyTerrain_HillProfile(): string { return 'Hill profile'; }
    public get propertyTerrain(): string { return 'Terrain'; }
    public get propertyTerrain_Type(): string { return 'Area'; }
    public get propertyTerrainType_Flat(): string { return 'Flat'; }
    public get propertyTerrainType_Bottom(): string { return 'Hill (Bottom surface)'; }
    public get propertyTerrainType_Top(): string { return 'Hill (Top surface)'; }
    public get propertyPointOfInterest(): string { return 'Point of interest'; }
    public get propertyWindowPane(): string { return 'Window pane'; }
    public get propertySill(): string { return 'Sill'; }
    public get PositionOfTheSun(): string { return 'Sun position'; }
    public get sun_Altitude(): string { return 'Altitude'; }
    public get sun_Azimuth(): string { return 'Azimuth'; }
    public get shadow_Softness(): string { return 'Softness'; }
}